<template>
  <v-dialog v-model="show" persistent max-width="350">
    <v-form ref="form" v-model="valid" lazy-validation data-cy="shipping-amount-modal">
      <v-card>
        <v-card-title class="text-h3 px-8 py-6 dialog-title">
          {{ $t('SHIPPING_MODAL_TITLE') }}
        </v-card-title>

        <v-divider />

        <v-container>
          <v-text-field
            dense
            :label="renderLabel(this.info.shippingAmount)"
            prepend-icon="mdi-pencil"
            type="number"
            class="d-flex align-center"
            v-model="amount"
            :rules="amountRules"
            required
          />
        </v-container>

        <v-divider />

        <v-card-actions class="d-flex justify-end pa-4">
          <v-btn
            class="non-text-transformation link"
            tile
            large
            outlined
            color="primary"
            @click.stop="show = false"
          >
            {{ $t('SHIPPING_MODAL_CANCEL') }}
          </v-btn>

          <v-btn
            tile
            large
            class="ml-4 non-text-transformation link"
            color="primary"
            @click="save()"
          >
            {{ $t('SHIPPING_MODAL_CHANGE') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
export default {
  props: ['value', 'info'],
  data() {
    return {
      valid: false,
      amount: this.value,
      amountRules: [
        v => !!v || this.$t('STEPPER_STEPINIT_SHIPPING_AMOUNT_VALIDATION_ERROR_NULL'),
        v =>
          Number(v) >= 0 || this.$t('STEPPER_STEPINIT_SHIPPING_AMOUNT_VALIDATION_ERROR_NEGATIVE'),
        v =>
          Number.isInteger(Number(v)) ||
          this.$t('STEPPER_STEPINIT_SHIPPING_AMOUNT_VALIDATION_ERROR_FLOAT'),
      ],
    }
  },
  computed: {
    show: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
  },
  methods: {
    changeShipping() {
      if (this.amount) {
        this.show = false
        this.$emit('changeShipping', this.amount, this.info)
      }
    },
    renderLabel(value) {
      if (!value) return
      return typeof value === 'number' ? String(value) : value
    },
    save() {
      if (this.$refs.form.validate()) {
        this.changeShipping()
      }
    },
  },
}
</script>
